
































































































































































































































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import _ from "lodash";
import Group from "@/components/miscellaneous/Group.vue";
import {Allocation, Request, Uuidable} from "@/modules/request/Request";
import Specifications from "@/components/forms/request/Specifications.vue";
import Documents from "@/components/forms/request/Documents.vue";
import {Action, Getter} from "vuex-class";
import {Topic} from "@/modules/Topic";
import {Title} from "@/modules/request/Title";
import RequestRepository from "@/repositories/request/RequestRepository";
import moment from "moment";
import {requestStatus, TYPE_CAMPAIGN} from "@/Constants";
import TitleRepository from "@/repositories/request/TitleRepository";
import SelectOwner from "@/components/owner/SelectOwner.vue";
import Owner from "@/model/cospirit-api/Owner";
import LabelValue from "@/components/miscellaneous/LabelValue.vue";
import RequestFormButtons from "@/components/forms/request/RequestFormButtons.vue";
import MoveRequest from "@/components/forms/request/MoveRequest.vue";

const components = {
    Group,
    Specifications,
    Documents,
    SelectOwner,
    LabelValue,
    RequestFormButtons,
    MoveRequest
};

@Component({components})
export default class RequestForm extends Vue {
    private request: Request | null = null;
    private loading: boolean = false;
    private needToSave: boolean = false;
    private editTopic: boolean = false;
    private showScopeOwnerSelect: boolean = true;
    private requestUuid: string | null = null;
    private editHeader: boolean = false;
    private selectedRequest: Request | null = null;
    private isDocumentsListDisplayed: boolean = false;
    private drawerVisible: boolean = false;
    private countDocument: number = 0;
    private hasMediaCampaign: boolean = false;
    private openMoveRequest: boolean = false;
    private parentRequest: Request | null = null;

    @Prop(Boolean) private visible!: boolean;

    @Getter("getCurrentOwnerUuid") public ownerUuid!: string;
    @Getter("getFilteredTopics") public filteredTopics!:
        (parentUuid: string | null, scopeOwnerUuid: string, withTopics: string[], allTopics: boolean) => Topic[];
    @Getter("getAllTopics") public allTopics!: Topic[];
    @Getter("getTopicScopeOwners") public topicScopeOwners!: string[];
    @Getter("getTitles") public titles!: (ownerUuid: string) => Title[];
    @Getter("isLocalMedia") public isLocalMedia!: boolean;
    @Getter("getMasterOwners") public allOwners!: Owner[];
    @Getter("getUserDepartment") public userDepartment!: string;
    @Getter("hasFeature") public hasFeature!: (feature: string) => boolean;

    @Action("loadBudgets") public refreshBudget!: () => void;

    @Watch("ownerUuid")
    private async changeOwner() {
        this.needToSave = false;
        if (!this.request) {
            await this.fetchData();
        }
    }

    @Watch("$route.params", {immediate: true, deep: true})
    private async onRouteChange() {
        this.requestUuid = this.$route.params.uuid || null;
        await this.fetchData();
    }

    @Watch("selectedRequest", { immediate: true })
    private updateSelectedRequest(newRequest: Request | null) {
        this.editTopic = !!newRequest && !newRequest.uuid;
    }

    private get disabledMoveRequest(): boolean {
        return !!this.selectedRequest && this.selectedRequest.children.length > 0;
    }

    private get changeClassByStatus() {
        if (this.selectedRequest?.status === requestStatus.draft) {
            return "request-form__form-button-group-draft";
        } else if (this.selectedRequest?.status === requestStatus.todo) {
            return "request-form__form-button-group-todo";
        } else {
            return "request-form__form-button-group";
        }
    }

    private get hasAllGeneralInformation(): boolean {
        return null !== this.request
            && this.request.title.length > 0
            && (this.request.description.length > 0 || this.hasFeature("OPTIONAL_DESCRIPTION"))
            && _.get(this.request, "topic.uuid", null) !== null
            && _.get(this.request, "subtopic.uuid", null) !== null;
    }

    private get isEditingOrNew() {
        if (this.selectedRequest) {
            return !this.selectedRequest.uuid;
        }
        return this.isCreatedRoute();
    }

    private get titleCanBeSaved() {
        const newTitle = _.get(this.selectedRequest, "title", "");

        if (3 > newTitle.length) {
            return false;
        }

        return _.every(this.titles(this.ownerUuid), (title: Title): boolean => {
            return title.label.toLocaleUpperCase() !== newTitle.toLocaleUpperCase();
        });
    }

    private get selectedScopeOwnerUuid(): string | null {
        return _.get(
            this.request,
            "scopeOwner.uuid",
            null
        );
    }

    private get canEditHeader(): boolean {
        return !!this.selectedRequest
            && (requestStatus.draft === this.selectedRequest.status ||
                requestStatus.todo === this.selectedRequest.status)
            && 0 === this.selectedRequest.children.length;
    }

    private get canEditTopic(): boolean {
        const request = this.parentRequest ? this.parentRequest : this.selectedRequest;
        return (
            (
                !_.get(this.selectedRequest, "uuid", false)
                || requestStatus.draft === _.get(this.selectedRequest, "status", false)
            ) && 0 === _.get(request, "children.length", 0)
        ) || this.editTopic;
    }

    private goToRequest(request: Request) {
        if (!request.uuid) {
            return;
        }
        this.$router.push({
            name: "edit_request",
            params: {
                uuid: request?.uuid ? request.uuid : "",
            },
        });
    }

    private canCreateMlCampaign(request: Request): boolean {
        return "" !== this.userDepartment && request.status !== "draft" && !this.hasMediaCampaign;
    }

    private cancel() {
        if (!this.requestUuid) {
            this.$router.push({name: "requests_list"});
        }
        this.selectedRequest = _.cloneDeep(this.request);
        this.editTopic = false;
    }

    private scrollToBottomIfScrollable(): void {
        this.$nextTick(() => {
            const container = document.querySelector(".request-form");
            if (!container) {
                return;
            }
            window.scrollTo(0, container.scrollHeight);
        });
    }

    private showableTopics(parentUuid: string | null, forcedScopeOwnerUuid: string | null = null): Topic[] {
        const scopeOwnerUuid = forcedScopeOwnerUuid ? forcedScopeOwnerUuid : this.selectedScopeOwnerUuid;
        if (!scopeOwnerUuid) {
            return [];
        }
        const filteredTopics = this.filteredTopics(
            parentUuid,
            scopeOwnerUuid,
            [
                _.get(this.request, "topic.uuid", null),
                _.get(this.request, "subtopic.uuid", null),
            ],
            false
        );

        return _.sortBy(filteredTopics, (line) => {
            return line.title;
        });
    }

    private isCreatedRoute() {
        return this.$router.currentRoute.name === "new_request";
    }

    private openLogs() {
        this.drawerVisible = true;
    }

    private updateStatus(status: string) {
        if (!this.request) {
            return;
        }
        this.request.status = status;
    }

    private changeTopic() {
        _.set(this.selectedRequest as object, "subtopic.uuid", null);
    }

    public canSave(request: Request) {
        return !this.loading
            && (request.area || this.hasFeature("OPTIONAL_ZONE"))
            && ((
                this.hasFeature("HIERARCHY_OWNER")
                && _.get(request, "hierarchyOwner.uuid", false)
            ) || !this.hasFeature("HIERARCHY_OWNER"))
            && _.get(request, "subtopic.uuid", null) !== null
            && request.brief
            && request.beginDate
            && request.endDate
            && request.title.length <= 255
            && request.description.length <= 255
            && _.some(request.allocations, (allocation: Allocation) => {
                return allocation.amount > 0.0;
            });
    }

    public titleSearch(queryString: string, cb: any): void {
        if (queryString.length < 2) {
            cb([]);
            return;
        }

        const result: Array<{ value: string }> = [];
        _.forEach(this.titles(this.ownerUuid), (title: Title, idx) => {
            const value: string = title.label.toLocaleUpperCase();
            if (value.indexOf(queryString.toLocaleUpperCase()) !== -1) {
                result.push({value: title.label});
            }
        });

        cb(result);
    }

    private saveTopic(): void {
        this.editTopic = false;

        if (_.get(this.selectedRequest, "uuid", false)) {
            const updateTopic = {
                uuid: _.get(this.selectedRequest, "uuid", false),
                topic: {
                    uuid: _.get(this.selectedRequest, "topic.uuid", false),
                },
                subtopic: {
                    uuid: _.get(this.selectedRequest, "subtopic.uuid", false),
                },
            };

            RequestRepository.save(updateTopic).then((data: object) => {
                this.$message({
                    message: _.invoke(this.$options.filters, "trans", "requestTopicHasBeenChanged"),
                    type: "success"
                });
            });
        }
    }

    private canEditRequest(request: Request): boolean {
        return requestStatus.draft === request.status || requestStatus.todo === request.status;
    }

    private retrieveHierarchyOwnerUuid(request: Request): string | null {
        return _.get(request, "hierarchyOwner.uuid", null);
    }

    private fetchParent() {
        if (!this.selectedRequest || !this.selectedRequest.parent) {
            return;
        }
        const params = {
            filters: {
                uuid: this.selectedRequest.parent.uuid,
            },
        };
        RequestRepository.get(params).then((data: object[]) => {
            if (data.length > 0) {
                this.parentRequest = data[0] as Request;
            }
        });
    }

    private async fetchData() {
        if (this.$router.currentRoute.params.uuid) {
            this.requestUuid = this.$router.currentRoute.params.uuid;
        }
        if (!this.ownerUuid) {
            return;
        }
        this.loading = true;
        if (this.requestUuid) {
            const params = {
                filters: {
                    uuid: this.requestUuid,
                },
            };
            RequestRepository.get(params).then((data: object[]) => {
                if (data.length > 0) {
                    const requestData = data[0] as Request;
                    if (this.ownerUuid !== requestData.owner.uuid) {
                        this.loading = false;
                        if ("" !== this.userDepartment) {
                            this.$router.push({
                              name: "edit_request",
                              params: { uuid: this.requestUuid ? this.requestUuid : "" },
                              query: { changeOwner: requestData.owner.uuid },
                            });
                        } else {
                            this.$router.push({ name: "requests_list" });
                        }

                        return;
                    }
                    this.request = requestData;
                    this.selectedRequest = requestData;
                    if (this.selectedRequest.parent) {
                        this.fetchParent();
                    } else {
                        this.parentRequest = null;
                    }
                }
                this.loading = false;
            });
        } else {
            const defaultData = {
                topic: {
                    uuid: null,
                },
                subtopic: {
                    uuid: null,
                },
                type: this.request ? this.request.type : TYPE_CAMPAIGN,
                area: "",
                owner: {
                    uuid: this.ownerUuid,
                },
                scopeOwner: {
                    uuid: null,
                },
                createdBy: {
                    displayName: "",
                },
                createdAt: moment().format("DD-MM-YYYY"),
            };

            RequestRepository.create({data: {owner: {uuid: this.ownerUuid}}}, defaultData).then((data: object) => {
                this.request = data as Request;
                this.selectedRequest = data as Request;
                this.loading = false;
            });
        }
    }

    private createChildRequest() {
        if (!this.request) {
            return;
        }
        const request = this.parentRequest ? this.parentRequest : this.request;
        this.loading = true;
        const defaultData = {
            title: request.title,
            description: request.description,
            topic: {
                uuid: request.topic!.uuid,
            },
            subtopic: {
                uuid: request.subtopic!.uuid,
            },
            type: request.type,
            area: "",
            owner: {
                uuid: request.owner.uuid,
            },
            scopeOwner: {
                uuid: request.scopeOwner!.uuid,
            },
            createdBy: {
                displayName: "",
            },
            createdAt: moment().format("DD-MM-YYYY"),
        };

        RequestRepository.create({data: {owner: {uuid: this.ownerUuid}}}, defaultData).then((data: object) => {
            if (!request) {
                return;
            }

            request.children.push(data as Request);
            this.selectedRequest = data as Request;
            this.loading = false;
        });
    }

    private save(request: Request, close: boolean) {
        this.loading = true;
        const requestData = this.parentRequest ? this.parentRequest : this.request;
        const localRequest: Uuidable = _.omit(request, "code", "children", "status", "followers");
        if (requestData && requestData.uuid && requestData.uuid !== localRequest.uuid) {
            _.set(localRequest, "parent.uuid", requestData.uuid);
        }

        _.set(localRequest, "allocations", this.cleanAllocations(request.allocations));
        _.unset(localRequest, "hierarchyOwner.fullName");

        const currentSubTopic = _.find(this.allTopics, (topic: Topic) => {
            return topic.uuid === _.get(this.selectedRequest, "subtopic.uuid", null);
        });
        const allocationMinError = this.hasFeature("minAmount")
            && _.find(_.get(localRequest, "allocations", []), (allocation: Allocation) => {
                return (_.isNull(allocation.amountMin) ? 0 : allocation.amountMin)
                    < _.get(currentSubTopic, "minAmount", 0);
            });

        const allocationError = _.find(_.get(localRequest, "allocations", []), (allocation: Allocation) => {
            return allocation.amount < (_.isNull(allocation.amountMin) ? 0 : allocation.amountMin);
        });

        if (allocationError) {
            this.$message({
                message: _.invoke(this.$options.filters, "trans", "allocationsMinMaxError"),
                type: "error"
            });
            this.loading = false;
            return;
        }

        if (allocationMinError) {
            this.$message({
                message: _.invoke(this.$options.filters, "trans", "allocationMinNotAllowed") +
                    " (" + _.get(currentSubTopic, "minAmount", 0) + " €)",
                type: "error"
            });
            this.loading = false;
            return;
        }

        RequestRepository.save(localRequest).then((data: object) => {
            this.refreshBudget();
            this.needToSave = false;
            if (this.$route.params.uuid !== _.get(data, "uuid")) {
                this.$router.push({
                    name: "edit_request",
                    params: {
                        uuid: _.get(data, "uuid"),
                    },
                });
            }
            this.loading = false;
        });
    }

    private cleanAllocations(allocations: Allocation[]): Allocation[] {
        return _.filter(allocations, (allocation: Allocation) => {
            return allocation.amount > 0;
        });
    }

    private closed() {
        this.request = null;
        this.$emit("closed");
    }

    private saveTitle(): void {
        const titleLabel = _.get(this.request, "title", "");

        if (!this.titleCanBeSaved) {
            return;
        }

        const title: Title = {
            uuid: null,
            label: titleLabel,
            owner: {
                uuid: this.ownerUuid,
            }
        };

        TitleRepository.save(title).then(() => {
            this.$store.dispatch("loadTitles");
        });
    }

    private updateSelectedOwner(ownerSelected: string, request: Request): void {
        if (!this.request) {
            return;
        }
        const requestData = this.parentRequest ? this.parentRequest : this.request;

        const newRequest = _.cloneDeep(requestData);

        if (this.isCreatedRoute()) {
            _.set(newRequest, "hierarchyOwner.uuid", ownerSelected);
            this.request = newRequest;
            this.selectedRequest = newRequest;
            return;
        }

        if (this.selectedRequest) {
            _.set(this.selectedRequest, "hierarchyOwner.uuid", ownerSelected);
        }
    }

    private updateScopeOwner(selectedScopeOwnerUuid: string): void {
        if (!this.request || !this.canEditHeader) {
            return;
        }
        // On reset l'entité hiérarchique si c'est un changement d'un scope à un autre et non de pas de scope à un scope
        if (
            this.hasFeature("HIERARCHY_OWNER")
            && null === _.get(this.request, "scopeOwner.uuid", null)
        ) {
            _.set(this.request, "hierarchyOwner.uuid", null);
        }
        _.set(this.request, "scopeOwner.uuid", selectedScopeOwnerUuid);
        // On reset la sélection de topic si le nouveau scope ne correspond pas au topic correspondant
        const selectedTopic = _.find(
            this.allTopics,
            (topic: Topic): boolean => {
                return topic.uuid === _.get(this.request, "topic.uuid", null);
            }
        );
        const selectedSubtopic = _.find(
            this.allTopics,
            (topic: Topic): boolean => {
                return topic.uuid === _.get(this.selectedRequest, "subtopic.uuid", null);
            }
        );

        const scopeOwnerUuidTopic = _.get(selectedTopic, "scopeOwner.uuid", null);
        const scopeOwnerUuidSubtopic = _.get(selectedSubtopic, "scopeOwner.uuid", null);
        if ((selectedTopic !== undefined && scopeOwnerUuidTopic !== selectedScopeOwnerUuid)
          || (selectedSubtopic !== undefined && scopeOwnerUuidSubtopic !== selectedScopeOwnerUuid)
        ) {
            _.set(this.request, "topic.uuid", null);
            _.set(this.request, "subtopic.uuid", null);
        }
    }

    private toggleScopeOwnerSelectVisibility(nbScopeOwnerOptions: number): void {
        this.showScopeOwnerSelect = 1 !== nbScopeOwnerOptions;
    }

    private updateSelectRequest(request: Request): void {
        if (!this.request) {
            return;
        }
        request.children.push(request);
        this.selectedRequest = request;
    }
}
